import React, { useCallback, useState } from 'react';
import TrueImpactRoundButton from 'shared/design-system/components/TrueImpactRoundButton';
import { faPen } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import TrueImpactModal from 'shared/design-system/components/TrueImpactModal';
import ProgramModalContent, {
  ProgramModalContentProps,
} from './ProgramModal/ProgramModalContent';

type ProgramEditButtonProps = Omit<ProgramModalContentProps, 'onClose'>

const buttonText = 'Edit Program';
const style = { marginTop: SPACERS.small };

const ProgramEditButton: React.FC<ProgramEditButtonProps> = ({
  isActive,
  programId,
  programName,
  allNPOUsers,
  programsList,
  reloadProgramList,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  if (!isActive) return null;
  const isLoading = programsList.type === 'REQUEST_START';
  return (
    <>
      <TrueImpactRoundButton
        icon={isLoading ? undefined : faPen}
        onClick={handleOpen}
        text={isLoading ? <TrueImpactLoading singleLine={true} /> : buttonText}
        style={style}
      />
      <TrueImpactModal
        onClose={handleClose}
        open={open}
        hideHeader={true}
        hideFooter={true}
      >
        <ProgramModalContent
          isActive={isActive}
          allNPOUsers={allNPOUsers}
          programId={programId}
          programName={programName}
          programsList={programsList}
          reloadProgramList={reloadProgramList}
          onClose={handleClose}
        />
      </TrueImpactModal>
    </>
  );
};

export default ProgramEditButton;
